/* eslint-disable no-console */
import React from 'react';
import { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { CircularProgress } from '@material-ui/core';
import useSev2UserCombobox from './hooks';

export const Sev2UserComboboxSchema = {
  uiOptions: {
    type: 'object',
    properties: {
      title: { type: 'string', title: 'Title', default: 'User' },
      description: {
        type: 'string',
        title: 'Description',
        default: 'Select a user',
      },
    },
  },
  returnValue: { type: 'object' },
};

export const Sev2UserCombobox = (
  props: FieldExtensionComponentProps<
    { name?: string; phid?: string, email?: string },
    { title: string; description: string }
  >,
) => {
  const { loading, open, setOpen, options, searchUsers } =
    useSev2UserCombobox();

  const { onChange, rawErrors, required, formData, uiSchema } = props;

  return (
    <FormControl
      margin="normal"
      required={required}
      error={rawErrors?.length > 0 && !formData}
    >
      <Autocomplete
        id="combo-box-project"
        open={open}
        onOpen={() => {
          setOpen(true);
        }}
        onClose={() => {
          setOpen(false);
        }}
        onInputChange={(_, value) => {
          searchUsers(value);
        }}
        onChange={(_, value) => {
          onChange({ name: value?.fields?.username, phid: value?.phid, email: value?.fields?.primaryEmail });
        }}
        getOptionSelected={(option, value) => option?.phid === value?.phid}
        getOptionLabel={option =>
          `${option.fields.username} (${option.fields.realName})`
        }
        options={options}
        loading={loading}
        renderInput={params => (
          <TextField
            {...params}
            label={uiSchema?.['ui:options']?.title}
            variant="standard"
            helperText={uiSchema?.['ui:options']?.description}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {loading ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        )}
      />
    </FormControl>
  );
};
